'use client'

import type { ReactNode } from 'react'

/** Standard content card; `padded=false` leaves body spacing to list/table callers. */
export function SectionCard({
  icon,
  title,
  action,
  children,
  padded = true,
}: {
  icon: ReactNode
  title: string
  action?: ReactNode
  children: ReactNode
  padded?: boolean
}) {
  const header = (
    <>
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex shrink-0 items-center text-accent">{icon}</span>
        <h3 className="truncate text-base font-medium text-ink">{title}</h3>
      </div>
      {action ? <div className="flex shrink-0 items-center gap-2">{action}</div> : null}
    </>
  )

  if (padded) {
    return (
      <div className="rounded-card border border-hair bg-white p-8 shadow-card">
        <div className="mb-8 flex items-center justify-between gap-4">{header}</div>
        {children}
      </div>
    )
  }

  return (
    <div className="rounded-card border border-hair bg-white shadow-card">
      <div className="flex items-center justify-between gap-4 border-b border-hair px-6 py-4">{header}</div>
      {children}
    </div>
  )
}
